"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    margin: 20px 0;\n    display: flex;\n    align-items: flex-start;\n    align-content: flex-start;\n    flex-direction: row;\n    flex-wrap: wrap;\n    justify-content: flex-start;\n    .tag {\n      margin: 5px;\n      a {\n        padding: 2px 10px 2px;\n        line-height: 2.0rem;\n        border-radius: 0 5px 5px 0;\n        background-color: #F3F3F3;\n        margin: 3px 5px 3px 20px;\n        position: relative;\n        color: #333333;\n        border: 1px solid #ddd;\n        border-left: 0;\n        z-index: 2;\n        transition: 0;\n        &:before {\n          content: \"\";\n          width: 2px;\n          height: 2px;\n          background: #777777;\n          position: absolute;\n          top: 11px;\n          left: -5px;\n          border-radius: 0;\n        }\n        &:after {\n          content: \"\";\n          width: 20px;\n          height: 20px;\n          background-color: #F3F3F3;\n          transform: rotate(45deg);\n          border-radius: 2px;\n          position: absolute;\n          top: 2px;\n          left: -9px;\n          z-index: -1;\n          border: 1px solid #ddd;\n          border-top: none;\n          border-right: none;\n          transition: 0;\n        }\n        &:hover {\n          background: #fff;\n          color: #000;\n          text-decoration: none;\n          transition: 0;\n        }\n        &:hover:after {\n          background: #fff;\n          color: #000;\n          text-decoration: none;\n          transition: 0;\n        }\n      }\n    }\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

function Tags(props) {
  var Wrapper = _styledComponents["default"].div(_templateObject());

  var label = props.label ? _react["default"].createElement("strong", null, props.label, ":") : '';
  var tags = props.tags.map(function (tag) {
    var ref = "{".concat(props.path).concat(tag.identifier);
    return _react["default"].createElement("div", {
      className: "tag",
      key: tag.identifier
    }, _react["default"].createElement("a", {
      href: ref
    }, " ", tag.title, " "));
  }, '<div></div>');
  return _react["default"].createElement(Wrapper, {
    className: "tag-wrapper"
  }, label, " ", tags);
}

var _default = Tags;
exports["default"] = _default;